<ion-app>
  <ion-split-pane *ngIf="api.pageName !== 'main' || auth.getIsLogin()" contentId="split-pane-content">
    <ion-menu contentId="split-pane-content" menuId="sideMenu" swipeGesture="false">
      <app-side-menu [avatar]="avatar"></app-side-menu>
    </ion-menu>
    <ion-content id="split-pane-content">
      <ion-header>
        <ion-toolbar>
          <ion-buttons slot="start">
            <ion-menu-button></ion-menu-button>
          </ion-buttons>
          <app-back-button></app-back-button>
          <button (click)="homePage()" class="logo"><img src="assets/img/icons/logo.png" alt="prestige dating"></button>
        </ion-toolbar>
      </ion-header>
      <ion-router-outlet id="content" ></ion-router-outlet><!--      [ngClass]="{'with-inbox-panel':(auth.isLogin$|async)}"-->
<!--      <app-inbox class="ion-hide-md-down fixed fixed-end-aside hide-header" *ngIf="auth.isLogin$|async"></app-inbox>-->
      <ng-container *ngIf="uiHelper.isBanner">
        <a class="link-banner" [ngClass]="{'not-login':!(auth.isLogin$ | async)}"
           *ngIf="banner?.img != '' && banner?.href != ''"
           (click)="goTo();">
          <img class="banner" src="{{ banner?.img}}" alt="banner">
        </a>
      </ng-container>

      <app-footer-menu *ngIf=" uiHelper.showFooter && (auth.isLogin$ | async) && !uiHelper.isKeyboardOpen" #ionFooter>
      </app-footer-menu>
    </ion-content>
  </ion-split-pane>
  <ng-container *ngIf="api.pageName == 'main' && !auth.getIsLogin()">
    <ion-content id="main-content">

      <ion-header [ngClass]="[api.deviceInfo.model=='iPhone9,3' ? 'iphone7' : '',api.isScroll ? 'scroll' : '',api.plt.is('ios') && !api.plt.is('mobileweb') ? 'ios' : '']">
        <ion-toolbar>
          <div class="toph1">
            <hr /><h1 >
            {{html?.top_header?.content}}</h1><hr />
          </div>
          <div [class.header-bg]="!auth.getIsLogin()">
            <div class="wrap">
              <div class="logo1"><a routerLink="{{linkReload}}"><img src="assets/img/icons/newlogo.png" alt="RichDate"></a></div>
              <div class="right-header">
                <div class="x-box font-resize">
                  <ul>
                    <li><a href="#" class="small" id="decfont">א</a></li>
                    <li><a href="#" id="resetf">א</a></li>
                    <li><a href="#" class="big" id="incfont">א</a></li>
                  </ul>
                </div>

                <div class="form" *ngIf="form && !auth.getIsLogin()" (click)="openLoginPopup(0)">
                  <div class="ion-margin-bottom" (click)="openLoginPopup(1)">
                    <input name="username" type="text" (click)="openLoginPopup(1)"
                           placeholder="{{ form.username.label }}"
                           enterkeyhint="next" inputmode="text" />
                  </div>

                  <div class="ion-margin-bottom" [ngClass]="displayErrors?'ion-invalid':'ion-valid'" (click)="openLoginPopup(2)">
                    <input name="password" type="password" (click)="openLoginPopup(2)"
                           placeholder="{{ form.password.label }}" enterkeyhint="send" inputmode="password" />
                  </div>

                  <!--                (click)="formSubmit()"-->
                  <div (click)="openLoginPopup(0)" class="login-btn three" tappable expand="block" (click)="openLoginPopup(0)">
                    {{ form.submit }}
                  </div>
                  <div (click)="openLoginPopup(0)" class="login-btn marg" tappable expand="block" (click)="openLoginPopup(0)">
                    להרשמה חינם
                  </div>

                  <a class="forgot-pwd" (click)="openLoginPopup(0)" style="display:inline-block;">{{ form.forgot_pwd }}</a>
                  <!--              routerLink="/password-recovery"-->

                </div>
              </div>
            </div>
          </div>
          <div *ngIf="displayErrors" class="login-error" style="text-align: center">
            <ion-note class="error" slot="error">{{ errors }}</ion-note>
          </div>
        </ion-toolbar>
      </ion-header>
      <ion-router-outlet id="main-content"></ion-router-outlet>
      <ng-container *ngIf="uiHelper.isBanner">
        <a class="link-banner" [ngClass]="{'not-login':!(auth.isLogin$ | async)}"
           *ngIf="banner?.img != '' && banner?.href != ''"
           (click)="goTo();">
          <img class="banner" src="{{ banner?.img}}" alt="banner">
        </a>
      </ng-container>
    </ion-content>
  </ng-container>
  <!--  <a class="link-banner"-->
  <!--     *ngIf="api.banner" [ngClass]="api.isLogin.getValue()?'login':''"-->
  <!--     (click)="bannerClick(api.banner);">-->
  <!--    <img class="banner" src="{{api.serverUrl + api.banner.img}}">-->
  <!--  </a>-->
</ion-app>
